export const tieredMenuStyles = {
  root: {
    class: [
      // Shape
      'rounded-md',

      // Size
      'min-w-[12rem]',
      'p-1.5',
      'px-2',

      // Colors
      'bg-surface-0 dark:bg-surface-700',
      'ring-1 ring-surface-200 dark:ring-surface-700',
    ],
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none',
    ],
  },
  menuitem: {
    class: ['relative first:mt-0 mt-4'],
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-md',

      //  Colors
      {
        'text-surface-500 dark:text-white/70': !context.focused && !context.active,
        'text-surface-500 dark:text-white/70 bg-surface-200 dark:bg-black/70': context.focused && !context.active,
        'text-surface-900 dark:text-surface-0/80 bg-surface-50 dark:bg-black/70': context.active,
      },

      // Hover States
      {
        'hover:bg-surface-50 dark:hover:bg-surface-800': !context.active,
        'hover:bg-surface-100 dark:hover:bg-black/40 text-surface-900 dark:text-surface-0/80': context.active,
      },

      // Transitions
      'transition-shadow',
      'duration-200',
    ],
  }),
  action: {
    class: [
      'relative',

      // Font
      'font-semibold',

      // Flexbox
      'flex',
      'items-center',

      // Spacing
      'py-2',
      'px-3',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none',
    ],
  },
  icon: {
    class: [
      // Spacing
      'mr-2',
      'leading-6',
      'text-sm',
    ],
  },
  label: {
    class: ['leading-none', 'text-3xl', 'sm:text-3xl'],
  },
  submenuicon: {
    class: [
      // Position
      'ml-auto',
    ],
  },
  submenu: {
    class: [
      // Size
      'w-full sm:w-48',

      // Spacing
      'sm:p-1.5',
      'sm:px-2',
      'sm:pb-4',
      'sm:m-0 sm:mx-1.5',
      'm-16 p-8',
      'list-none',

      // Shape
      'shadow-none sm:shadow-md',
      'border-0',

      // Position
      'absolute',
      'z-50',

      // Color
      'bg-surface-0 dark:bg-surface-700',
    ],
  },
  separator: {
    class: 'border-t border-surface-200 dark:border-surface-600 my-1',
  },
};
